(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/integration-test', {
      templateUrl: 'modules/app/integration-test/integration-test.html',
      controller: 'IntegrationTestCtrl'
    });
  }]).
  /**
   * About Page
   */
  controller('IntegrationTestCtrl', ['$http', '$scope', '$timeout', 'Api', 'User', 'Utils', function ($http, $scope, $timeout, Api, User, Utils) {
    var session = User.get();
    $scope.providerName = "xAPI Apps";
    $scope.launchUrl = "";
    $scope.key = "";
    $scope.secret = "";
    $scope.launch = function launch() {
      var startUrl = Utils.appendParams(Api.url("/integration/start"), {
        name: $scope.providerName
      });
      $http.post(startUrl).then(function success(response) {
        $scope.key = response.data.key;
        $scope.secret = response.data.secret;
        $scope.orgId = session.organization.id;
        $scope.orgName = session.organization.name;
        $scope.userName = session.user.name;
        $scope.userEmail = session.user.email;
        $timeout(function () {
          $("#launchForm").attr('action', $scope.launchUrl).submit();
        });
      }, function error() {});
    };
  }]);
})();
